import React from 'react';
import { FileText, Image, X as XIcon } from 'lucide-react';

export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function AttachmentList({ attachments, onRemove }) {
  if (!attachments?.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5">
      {attachments.map((att, i) => (
        <div key={att.name || `att-${i}`} className="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-muted/30 border border-border/30 text-[9px] group">
          {att.type?.startsWith('image/') ? <Image className="w-3 h-3 text-primary" /> : <FileText className="w-3 h-3 text-muted-foreground" />}
          <span className="text-foreground truncate max-w-[120px]">{att.name}</span>
          <span className="text-muted-foreground/70">{(att.size / 1024).toFixed(0)}KB</span>
          {onRemove && <button onClick={() => onRemove(i)} className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-destructive"><XIcon className="w-2.5 h-2.5" /></button>}
        </div>
      ))}
    </div>
  );
}

export function AttachmentDisplay({ attachments }) {
  if (!attachments?.length) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {attachments.map((att, i) => (
        <div key={att.name || `att-${i}`} className="rounded-lg border border-border/30 overflow-hidden">
          {att.data_url?.startsWith('data:image/') ? (
            <img src={att.data_url} alt={att.name} className="max-h-24 max-w-[160px] object-cover" />
          ) : (
            <a href={att.data_url} download={att.name} className="flex items-center gap-1.5 px-3 py-2 text-[10px] text-primary hover:bg-primary/5 transition-colors">
              <FileText className="w-3.5 h-3.5" /> {att.name} <span className="text-muted-foreground">({(att.size / 1024).toFixed(0)}KB)</span>
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export const fmtDate = (iso) => iso ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
